import { Box, Typography } from "@mui/material";

const Payroll = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" fontWeight="bold">
        Payroll
      </Typography>
    </Box>
  );
};

export default Payroll;